module.exports = __webpack_public_path__ + "static/bsmart-logo-d50023b4865a4860bc3e8af2cfecd40f.jpg";